var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"color badge",class:`badge bg-${_vm.color}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }